import React from "react";
import { motion } from "framer-motion";
import styles from "./HomeSection.module.css";

import { useNavigate } from "react-router-dom";

const HomeSection = () => {
  const navigate = useNavigate()

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }
    }
  };

  const imageReveal = {
    hidden: { opacity: 0, scale: 1.05 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1.2, ease: "easeOut" }
    }
  };

  const handleNavigate = () => {
    navigate("/menu")
  }

  return (
    <section className={styles.sectionWrapper}>
      <div className={styles.container}>

        {/* ===== TOP GRID ===== */}
        <div className={styles.topGrid}>
          <motion.div
            className={styles.leftContent}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={{
              visible: { transition: { staggerChildren: 0.15 } }
            }}
          >
            <motion.img
              variants={fadeInUp}
              src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/DSC08019.jpg"}
              className={styles.smallImg}
              alt="Food detail"
            />

            <motion.h2 variants={fadeInUp} className={styles.title}>
              Moments  <br /> That Stay <br /> With You
            </motion.h2>

            <motion.p variants={fadeInUp} className={styles.desc}>
            From intimate dinners to larger celebrations, every experience is shaped with thoughtful details, warm hospitality, and a setting that encourages people to gather, connect, and stay longer, creating moments that feel effortless, personal, and naturally memorable long after the evening ends.

            </motion.p>

          </motion.div>

          <motion.div
            className={styles.rightImage}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={imageReveal}
          >
            <img src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/LAH%20-%2015.jpg"} alt="Restaurant interior" />
          </motion.div>
        </div>

        {/* ===== MENU SECTION ===== */}
        <motion.div
          className={styles.menuSection}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={{
            visible: { transition: { staggerChildren: 0.2 } }
          }}
        >
          <motion.img
            variants={fadeInUp}
            src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/DSC09155%20(1).jpg"}
            className={styles.menuDish}
            alt="Signature dish"
          />

          <motion.p variants={fadeInUp} className={styles.menuLabel}>
            Our Menu
          </motion.p>

          <motion.h3 variants={fadeInUp} className={styles.menuTitle}>
            Designed around seasonality and flavour, the menu offers thoughtful dishes that feel vibrant, refined, and deeply satisfying.

          </motion.h3>

          <motion.button onClick={handleNavigate} variants={fadeInUp} className={styles.menuBtn}>
            View Menus
          </motion.button>
        </motion.div>

        {/* ===== BIG IMAGE ===== */}
        <motion.div
          className={styles.bottomImage}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/image12.png"} alt="Large food spread" />
          {/* <img src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/From%20sushi%20to%20sliders%2C%20spice%20to%20subtlety%E2%80%94this%20table%20does%20borders%20better%20than%20a%20passport.%20Flavors%20(1).jpg"} alt="Large food spread" /> */}
        </motion.div>

      </div>
    </section>
  );
};

export default HomeSection;